import { PrimaryButton, Stack } from "@fluentui/react";
import { Card, Text, tokens } from "@fluentui/react-components";
import { Image } from "@fluentui/react/lib/Image";
import copilotIcon from "../../../../../assets/copilot.svg";
import { PRODUCT_VIEW_STYLES as styles } from "../../../Common/ProductView.styles";

export const AISummaryCardContainer = () => (
  <Card style={{ marginInline: tokens.spacingVerticalL }}>
    <Stack
      horizontal
      styles={styles.PRODUCT_LIST.CSS_STYLES.aiSummaryCardStack}
      tokens={{ childrenGap: 6 }}
      verticalAlign="center"
    >
      <Image alt="Copilot logo" height={18} src={copilotIcon} />
      <Text weight="semibold">AI Summary</Text>
      <Text truncate wrap className={styles.PRODUCT_LIST.CLASS_NAMES.aiSummaryCardDescription}>
        To be added soon. Stay tuned.
      </Text>
      <PrimaryButton styles={styles.PRODUCT_LIST.CSS_STYLES.aiSummaryCardViewMoreButton}>View More</PrimaryButton>
    </Stack>
  </Card>
);
